module.exports = __webpack_public_path__ + "img/jqr.f1c1a2d6.jpg";